/**
 * Copyright (c) 2025, CYBRA Corp. All rights reserved.
 */
import { Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import {ApiTokenHeader} from "../models/api-token";
import {ApiTokenService} from "../services/apitoken.service";
import {PAGING_ITEMS_PER_PAGE} from "../app-constants";
import { PagedResults } from "app/models/paged-results";

@Injectable()
//@Input()
export class ApiTokenPagingResolver implements Resolve<PagedResults<ApiTokenHeader>> {

  constructor(
    private  apiTokenService: ApiTokenService,

  ) {}

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<PagedResults<ApiTokenHeader>> {
    try {
      return await this.apiTokenService.getApiTokenHeaders(0, PAGING_ITEMS_PER_PAGE, 'ASC', "");
    } catch (error) {
      console.error("Problem resolving Locations... Error: " + error, error);
    }
  }

}
